// Available consulting services for payment
export const CONSULTING_SERVICES = {
  CREDITS: {
    id: 'credits',
    name: 'OpenKBS Platform Credits',
    description: 'Deposit for OpenKBS Platform Credits',
    bulgarianName: 'OpenKBS кредити за използване',
    bulgarianDescription: 'Депозит за OpenKBS кредити',
    taxCode: 'txcd_10000000',
    type: 'credits'
  },
  DEVELOPMENT: {
    id: 'development',
    name: 'Development Service',
    description: 'Custom development and implementation services',
    bulgarianName: 'Услуги за разработка',
    bulgarianDescription: 'Персонализирани услуги за разработка и внедряване',
    taxCode: 'txcd_37071011', // Software Maintenance Agreement - Optional, Custom, Services Only
    type: 'consulting'
  },
  SUPPORT: {
    id: 'support',
    name: 'Technical Support Service',
    description: 'Technical support and maintenance services',
    bulgarianName: 'Техническа поддръжка',
    bulgarianDescription: 'Услуги за техническа поддръжка и поддържане',
    taxCode: 'txcd_37071003', // Software Maintenance Agreement - Optional, Prewritten, Services Only
    type: 'consulting'
  },
  INTEGRATION: {
    id: 'integration',
    name: 'Integration Service',
    description: 'System integration and API development services',
    bulgarianName: 'Интеграционни услуги',
    bulgarianDescription: 'Услуги за системна интеграция и разработка на API',
    taxCode: 'txcd_37071011', // Software Maintenance Agreement - Optional, Custom, Services Only
    type: 'consulting'
  },
  CONSULTING: {
    id: 'consulting',
    name: 'Consulting Service',
    description: 'General consulting and advisory services',
    bulgarianName: 'Консултантски услуги',
    bulgarianDescription: 'Общи консултантски и съветни услуги',
    taxCode: 'txcd_37071003', // Software Maintenance Agreement - Optional, Prewritten, Services Only
    type: 'consulting'
  }
};

export const getServiceById = (serviceId) => {
  return Object.values(CONSULTING_SERVICES).find(service => service.id === serviceId) || CONSULTING_SERVICES.CREDITS;
};

export const getServiceName = (serviceId, isBulgarian = false) => {
  const service = getServiceById(serviceId);
  return isBulgarian ? service.bulgarianName : service.name;
};

export const getServiceDescription = (serviceId, isBulgarian = false) => {
  const service = getServiceById(serviceId);
  return isBulgarian ? service.bulgarianDescription : service.description;
};